import { render } from "./AppSvg.vue?vue&type=template&id=df6f09c0"
import script from "./AppSvg.vue?vue&type=script&lang=js"
export * from "./AppSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__